import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { AvatarComponent } from "src/app/design-system/components/avatar/avatar.component";

@Component({
    selector: "ds-status-badge",
    imports: [CommonModule, AvatarComponent],
    templateUrl: "./status-badge.component.html",
    styleUrl: "./status-badge.component.scss"
})
export class StatusBadgeComponent {
  @Input() color = ""; // Can be grey, blue, red, orange and green
  @Input() text = ""; // Status text to display in the badge
  @Input() user = null; // User object with name and avatar
}
